// Store locator with customisations
// - custom marker
// - custom info window (using Info Bubble)
// - custom info window content (+ store hours)

var ICON = new google.maps.MarkerImage('https://cdn.shopify.com/s/files/1/1689/5369/files/aspgear-map-marker.png?528541107326435755', null, null,
    new google.maps.Point(14, 13));

  

google.maps.event.addDomListener(window, 'load', function() {
  var map = new google.maps.Map(document.getElementById('map-canvas'), {
    center: new google.maps.LatLng(47.629200, -97.006693),
    zoom: 4,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  styles: [{
    stylers: [{
      saturation: -100
    }]
    }]
  });

  var panelDiv = document.getElementById('panel');

  var data = new MedicareDataSource;

  var view = new storeLocator.View(map, data, {
    geolocation: true
  });

  view.createMarker = function(store) {
    var markerOptions = {
      position: store.getLocation(),
      icon: ICON,
      title: store.getDetails().title
    };
    return new google.maps.Marker(markerOptions);
  }

  var infoBubble = new InfoBubble({ minWidth : 300 });
  view.getInfoWindow = function(store) {
    if (!store) {
      return infoBubble;
    }

    var details = store.getDetails();
	
	if( details.website ){
		var html = ['<div class="store"><div class="title">', details.title,
      '</div><div class="address">', details.address, '<div class="webiste"><a href="'+details.website+'">'+details.website+'</div></div>',
      '</div>'].join('');
	} else{
		var html = ['<div class="store"><div class="title">', details.title,
      '</div><div class="address">', details.address, '</div>',
      '</div>'].join('');
	}
    

    infoBubble.setContent($(html)[0]);
    return infoBubble;
  };

  new storeLocator.Panel(panelDiv, {
    view: view
  });
});